import httpClient from '../httpClient';

const get = async (id) => {
  return await httpClient.get(`/term_places/${id}`);
};
const post = async (data) => {
  return await httpClient.post(`/term_places/`, data);
};
const put = async (id, data) => {
  return await httpClient.put(`/term_places/${id}/`, data);
};
const remove = async (id) => {
  return await httpClient.delete(`/term_places/${id}`);
};

const assignResumes = async (id, data) => {
  return await httpClient.patch(`/term_places/${id}/assign_resumes/`, data);
};

const unassignResume = async (id) => {
  return await httpClient.patch(`/term_place_resume/${id}/unassign_resume/`);
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = 'id',
  search = '',
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `/term_places/export/?filter[termino]=${query}${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/term_places/?filter[termino]=${query}&page[number]=${page}&page[size]=${pageSize}${searchBy}`,
    );
};

const resumeTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = 'id',
  search = '',
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `/term_place_resume/export/?filter[termino]=${query}${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/term_place_resume/?filter[termino]=${query}&page[number]=${page}&page[size]=${pageSize}${searchBy}`,
    );
};

export {
  get,
  post,
  put,
  remove,
  ajaxTable,
  resumeTable,
  assignResumes,
  unassignResume,
};
